import { createPortal } from 'react-dom';
import { Suspense, lazy } from 'react';
import { REACT_ROOT_MAIN } from '@app/constants/targets';
import ExceptionBoundary from '@app/components/common/Exception/ExceptionBoundary';
import EquipmentInfoLoader from './EquipmentInfo/EquipmentInfoLoader/EquipmentInfoLoader';
const AssetLandingPage = lazy(() => import('./AssetLandingPage'));

const Container = () => {
  return createPortal(
    <ExceptionBoundary>
      <Suspense fallback={<EquipmentInfoLoader />}>
        <AssetLandingPage />
      </Suspense>
    </ExceptionBoundary>,
    document.getElementById(REACT_ROOT_MAIN)
  );
};

export default Container;
